<template>
	<div id='commonFunctions'>
		 <el-dialog 
            title="常用功能设置" 
            :visible.sync='isShow' 
            width="850px"
            class='default-dialog'
            >
            <div v-loading='isLoading'>
            	<div class="commonFunctions_c">
            		<div class="commonFunctions_d">
            			<div class='item' v-for='item in menu' :key='item.id'>
					   		<span class="title">{{item.name}}</span>
					   		<el-checkbox-group v-model="item.model">
								<el-checkbox v-for='i in item.children' :label="i.id" class='checkBox' :key='i.id'>{{i.name}}</el-checkbox>
							</el-checkbox-group>
						
						</div>
            		</div>
	            </div>
	            <div class="footer"  >
					<el-button @click='sendMessage' class='minButton'>确认设置</el-button>
				</div>
            </div>
        </el-dialog>
	</div>
</template>
<script>
	export default {
		props: {
			showVisible: Boolean
		},
		data() {
			return {
				checkList: [],
				menu: [],
				isLoading: false,
			}
		},
		created() {
			this.getCommonFunctions();

		},
		computed: {
			// 显示弹窗
			isShow: {
				get () {
					return this.showVisible;
				},
				set (val) {
					this.$emit('update:showVisible', val);
				}
			},
		},
		methods: {
			isShowBoolean() {
				this.isShow=false;
			},
			// 提交功能设置
			sendMessage() {
				let menuIds= [];
				
				try {
					this.menu.forEach(i=>{
						if(i.model.length){
							i.model.forEach(i=>{
								menuIds.push(i);
							})
						}
					})
					menuIds = [...new Set(menuIds)]
					if(menuIds.length>4) {
						return this.$message.warning('常用功能设置不能多于四个！')
					}
					if(!menuIds.length) {
						this.$confirm('系统检测到您当前没有设置常用功能, 是否启用默认选项?', '提示', {
				          	confirmButtonText: '确定',
				          	cancelButtonText: '取消',
				          	type: 'warning'
				        }).then(()=>{
				        	this.isLoading = true;
							this.$http.post('frequentlyUsed/saveFrequenlyUsed' , {menuIds: menuIds.toString()}).then(res=>{
								if(res && res.data.code == 1) {
									this.$message.success('操作成功！')
									this.getCommonFunctions();
									this.isLoading = false;
									this.isShow = false;
								}
							})
				        }).catch(()=>{
				        	
				        })
					}else {
						this.isLoading = true;
						this.$http.post('frequentlyUsed/saveFrequenlyUsed' , {menuIds: menuIds.toString()}).then(res=>{
							if(res && res.data.code == 1) {
								this.$message.success('操作成功！')
								this.getCommonFunctions();
								this.isLoading = false;
								this.isShow = false;
							}
						})
					}
				}catch(e) {
					this.isLoading = false;
				}
				
			},
			// 获取常用功能设置
			getCommonFunctions() {
				this.$http.post('frequentlyUsed/getFrequenlyUsed' , {}).then(res=>{
					if(res && res.data.code == 1) {
						if(res && res.data.code == 1) {
							this.$emit('getMenuList' , res.data.data);
							res.data.data.forEach(i=>{
								this.menu.forEach(j=>{
									if(j.children.length) {
										j.children.forEach(k=>{
											if(k.id==i.id) {
												j.model.push(k.id);
											}
										})
									}
								})
							})
						}
					}
				})
			},
			// 获取菜单
			getMenu() {
				let menus = this.$getSessionStorage('menu');
				this.menu=[];
				if(menus.length) {
					menus.forEach((i,index)=>{
						if(i.children.length){
							i.model=[];
							this.menu.push(i)
						}
					})
					this.getCommonFunctions();
				}
				
			},
		},
		watch: {
			isShow(val) {
				if(val) {
					this.getMenu();
				}
			}
		}
	}
</script>
<style lang='less' scoped>
	#commonFunctions {
		.commonFunctions_c {
			text-align: center;
			overflow: hidden;
			width:100%;
			.commonFunctions_d {
				display: inline-block;
				.item {
					float: left;
					padding: 20px 20px 0;
					height: 100%;
					text-align: left;
					.title {
						display: block;
						font-weight: bold;
						font-size: 16px;
						margin-bottom: 10px;
					}
					.checkBox {
						display: block;
						padding: 5px 0;
					}
				}
			}
			
			
		}
		.footer {
			width: 100%;
			text-align: center;
			padding: 20px 0 0px;
			border-top: 1px solid #999;
		}
		
	}
	
</style>


// WEBPACK FOOTER //
// src/components/dialog/commonFunctions.vue